module.exports = __webpack_public_path__ + "img/pricingpopup.216b9713.svg";